import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { editCheckoutQuestion } from "store/actions/checkoutQuestionAction";
const EditCheckoutModal = ({
  editModal,
  editToggle,
  editQuestion,
  setEditQuestion,
}) => {
  const dispatch = useDispatch();
  const { editLoading } = useSelector((state) => state.checkoutQuestion);

  const handleModalClick = (e) => {
    if (e.target.closest(".modal-content")) {
      return;
    }
    editToggle();
  };

  const handleCatalogSubmit = (e) => {
    e.preventDefault();
    dispatch(
      editCheckoutQuestion(editQuestion, () => {
        editToggle();
      })
    );
  };

  return (
    <div>
      <Modal isOpen={editModal} toggle={editToggle} onClick={handleModalClick}>
        <ModalHeader toggle={editToggle}>
          Edit Question Details
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleCatalogSubmit}>
            <Row>
              <Col>
                <Label>Question</Label>

                <Input
                  type="text"
                  required
                  name="title"
                  value={editQuestion.title}
                  placeholder="Question"
                  onChange={(e) =>
                    setEditQuestion({ ...editQuestion, title: e.target.value })
                  }
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <FormGroup>
                  <Label>Type</Label>
                  <Input
                    type="select"
                    id="exampleCustomSelect"
                    name="type"
                    required
                    value={editQuestion.type}
                    onChange={(e) =>
                      setEditQuestion({ ...editQuestion, type: e.target.value })
                    }
                  >
                    <option value="" selected disabled>
                      Select Type
                    </option>
                    <option value="marketing">Marketing</option>
                    <option value="order">Order</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div className="form-check w-100 p-0 d-flex align-items-center justify-content-start">
              <Input
                type="checkbox"
                className="form-check-input timing-modal-checkbox m-0"
                id="applyAllCheckbox"
                value={editQuestion.isMandatory}
                checked={editQuestion.isMandatory}
                onChange={(e) =>
                  setEditQuestion({
                    ...editQuestion,
                    isMandatory: e.target.checked,
                  })
                }
              />
              <label
                className="form-check-label timing-modal-checkbox-label ml-2"
                htmlFor="applyAllCheckbox"
              >
                isMandatory
              </label>
            </div>

            <Row>
              <Col>
                <div className="d-flex justify-content-end ">
                  <Button color="primary" disabled={editLoading}>
                    {editLoading ? <Spinner size="sm" /> : "Update"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default EditCheckoutModal;
